export default "__VITE_ASSET__UwL1tf5c__"